import React, { useState } from "react";
import { RepInfo } from "~/common/Store/models/User";
interface Props {
  repInfo: RepInfo;
}
const CustomerRepContact = ({
  repInfo
}: Props) => {
  const images = repInfo?.images?.length > 0 ? repInfo?.images?.map(i => i?.imagePath) : ["/uploads/images/2019/2/platinum-rep-missing-img.jpg"];
  const totalImages = images?.length;
  const [repImageIndex, setRepImageIndex] = useState(0);
  const [timeout, setTimeout] = useState<NodeJS.Timeout>();
  const handleMouseEnter = () => {
    if (!timeout) {
      const newTimeout = setInterval(() => {
        setRepImageIndex(index => (index + 1) % totalImages);
      }, 500);
      setTimeout(newTimeout);
    }
  };
  const handleMouseLeave = () => {
    if (timeout) {
      clearInterval(timeout);
      setRepImageIndex(0);
      setTimeout(undefined);
    }
  };
  return <div className="flex flex-row justify-start items-center flex-grow-0 flex-shrink-0 space-x-0 xxxs:space-x-2 border-r-0 sm:border-r border-l-0 border-t-0 border-b sm:border-b-0 border-solid border-gray-200 pb-2 sm:pr-4 pl-2" data-sentry-component="CustomerRepContact" data-sentry-source-file="index.tsx">
      {totalImages > 0 && <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className="w-20 xxxs:w-24 lz:w-32 h-auto xxxs:h-16 lz:h-24 rounded overflow-hidden flex justify-center items-center">
          <img src={images[repImageIndex]} alt="platinum rep profile" data-testid="platinum-rep-image" className="h-full mx-auto xxxs:ml-auto xxxs:mr-2" />
        </div>}
      <div className="pl-4 xxxs:pl-0 flex flex-col justify-center items-start">
        <h3 className="ml-0 mb-2 text-lg font-semibold leading-none text-gray-800" data-testid="platinum-rep-name">
          {repInfo.name}
        </h3>
        <p className="mb-0 leading-none text-xs font-regular text-gray-800" data-testid="platinum-rep-phone">
          {repInfo.phone}
        </p>
        <a className="mb-0 leading-none text-xs font-regular text-green-500" href="mailto:platinum@webstaurantstore.com" data-testid="platinum-rep-email">
          platinum@webstaurantstore.com
        </a>
      </div>
    </div>;
};
export default CustomerRepContact;